<script setup lang="ts">
import type { PropType } from "vue";

defineProps({
    light: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        required: true
    },
    subTitle: {
        type: String,
        default: undefined
    },
    paragraph: {
        type: String,
        default: undefined
    },
    src: {
        type: String,
        required: true
    },
    alt: {
        type: String,
        required: true
    },
    titleCards: {
        type: String,
        default: undefined
    },
    cards: {
        type: Array as PropType<
            {
                title: string;
                text?: string;
            }[]
        >,
        default: () => []
    }
});
</script>

<template>
    <section>
        <div :class="{ 'section-wrapper': !light }">
            <div class="pa-4 pa-md-10 text-center" style="max-width: 80rem; margin: 0 auto">
                <CmsSubTitle v-if="subTitle" :text="subTitle" />
                <CmsTitle variant="title-1" class="text-primary" :text="title" />
                <CmsParagraph v-if="paragraph" :text="paragraph" />
                <slot name="info" />
            </div>
        </div>
        <Image
            hide-shining
            :src="src"
            :alt="alt"
            sizes="100vw sm:600px md:960px lg:1280px xl:1920px"
            styles="object-position: top; width:100%; height: auto;"
        />
        <div v-if="cards.length" class="pa-4 pa-md-10" style="max-width: 80rem; margin: 0 auto; overflow: hidden">
            <CmsTitle variant="title-2" class="text-center" :text="titleCards" />
            <VRow class="mt-10" justify="center" align="stretch">
                <VCol v-for="(card, i) in cards" :key="i" style="min-width: 300px; max-width: 350px">
                    <div style="width: 50px" class="mx-auto">
                        <VImg
                            :src="`/img/products/lenses/essilor/icon-1.webp`"
                            alt="Ikona."
                            sizes="100vw sm:50px"
                            styles="object-position: top; width:100%; height: auto;"
                        />
                    </div>
                    <VCard variant="flat" elevation="0" class="fill-height text-center">
                        <VCardTitle class="text-h6 font-weight-bold" style="word-wrap: break-word; hyphens: none; white-space: normal">{{
                            card.title
                        }}</VCardTitle>
                        <VCardText v-if="card.text">{{ card.text }}</VCardText>
                    </VCard>
                </VCol>
            </VRow>
        </div>
        <slot />
    </section>
</template>
